import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { useLocation } from 'react-router-dom';
import { LOGOUT_REASONS } from '@commercetools-frontend/constants';
import { u as useIsServedByProxy } from './use-is-served-by-proxy-a383da4b.esm.js';
import { g as getMcOrigin } from './get-mc-origin-fecfee07.esm.js';
import { R as RedirectToLogin } from './index-bdd71e4c.esm.js';
import { R as Redirector } from './redirector-76670a54.esm.js';
import { jsx } from '@emotion/react/jsx-runtime';
import '@commercetools-frontend/application-shell-connectors';
import '@babel/runtime-corejs3/helpers/slicedToArray';
import '@babel/runtime-corejs3/core-js-stable/url';
import '@babel/runtime-corejs3/core-js-stable/instance/reverse';
import 'prop-types';
import 'react';
import './index-b6081c20.esm.js';
import '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import '@babel/runtime-corejs3/core-js-stable/object/entries';
import '@babel/runtime-corejs3/core-js-stable/reflect/has';
import '@reduxjs/toolkit';
import 'lodash/mapValues';
import 'omit-empty-es';
import 'redux-thunk';
import '@commercetools-frontend/notifications';
import '@commercetools-frontend/sdk';
import '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '@babel/runtime-corejs3/core-js-stable/instance/includes';
import '@commercetools-frontend/sentry';
import '@commercetools-frontend/react-notifications';
import '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import 'redux-logger';
import '@emotion/styled/base';
import '@babel/runtime-corejs3/core-js-stable/instance/find';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@emotion/react';
import '@commercetools-frontend/application-components';
import '@commercetools-frontend/i18n';
import './oidc-b2520905.esm.js';
import '@babel/runtime-corejs3/core-js-stable/instance/map';
import '@commercetools-uikit/design-system';
import '@commercetools-uikit/spacings';
import 'react-intl';
import '@commercetools-uikit/flat-button';
import '@commercetools-uikit/icons';
import './location-f21dbc25.esm.js';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import 'memoize-one';
import 'react-select';
import '@commercetools-uikit/accessible-hidden';
import '@commercetools-uikit/select-input';
import '@commercetools-uikit/text';
import '@commercetools-frontend/assets/images/ct-logo.svg';
import '@commercetools-uikit/loading-spinner';
import '@commercetools-frontend/browser-history';
import '@commercetools-frontend/l10n';
import '@babel/runtime-corejs3/core-js-stable/reflect/construct';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/helpers/inherits';
import '@babel/runtime-corejs3/helpers/possibleConstructorReturn';
import '@babel/runtime-corejs3/helpers/getPrototypeOf';
import '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import '@babel/runtime-corejs3/core-js-stable/instance/flags';
import '@apollo/client/react';
import '@flopflip/combine-adapters';
import '@flopflip/http-adapter';
import '@flopflip/launchdarkly-adapter';
import '@flopflip/react-broadcast';
import '@flopflip/types';
import 'react-redux';
import '@commercetools-uikit/design-system/materials/resets.css';
import '@commercetools-frontend/application-config/ssr';
import '@commercetools-frontend/permissions';
import '@flopflip/memory-adapter';
import '@babel/runtime-corejs3/core-js-stable/json/stringify';
import '@babel/runtime-corejs3/core-js-stable/instance/some';
import '@commercetools-frontend/actions-global';
import 'qss';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
// When the application redirects to this route, we always force a hard redirect
// to the logout route of the authentication service.
const RedirectToLogout = props => {
  const location = useLocation();
  const servedByProxy = useIsServedByProxy();
  if (window.app.__DEVELOPMENT__?.oidc?.authorizeUrl) {
    return jsx(RedirectToLogin, {});
  }
  const mcOrigin = servedByProxy ? getMcOrigin(window.app.mcApiUrl) : undefined;
  return jsx(Redirector, {
    to: "logout",
    origin: mcOrigin,
    location: location,
    queryParams: _objectSpread({
      reason: props.reason ?? LOGOUT_REASONS.USER
    }, servedByProxy ? {} : {
      // This will be used after being logged in, to redirect to this location.
      redirectTo: window.location.origin
    })
  });
};

export { RedirectToLogout as default };
